"use strict";
/**
 * Provide access to
 * {@link UpdateConstraint UpdateConstraint},
 * {@link UpdateConstraintFactory UpdateConstraintFactory},
 * {@link PartialJSON PartialJSON},
 * {@link TopicCreationResult TopicCreationResult}, and
 * {@link UpdateStream UpdateStream}.
 *
 * @module diffusion.topicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:variable-name */
/**
 * Result indicating whether the operation caused a topic to be created or if
 * it already existed.
 *
 * @since 6.2
 */
var TopicCreationResult;
(function (TopicCreationResult) {
    /**
     * A new topic was created.
     */
    TopicCreationResult[TopicCreationResult["CREATED"] = 1] = "CREATED";
    /**
     * A topic with the same specification already exists.
     */
    TopicCreationResult[TopicCreationResult["EXISTS"] = 2] = "EXISTS";
})(TopicCreationResult = exports.TopicCreationResult || (exports.TopicCreationResult = {}));
exports.TopicUpdateNamespace = {
    TopicCreationResult: TopicCreationResult
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/topic-update/topic-update.js
// module id = 110
// module chunks = 1